/**
 * Which signal kinds actually satisfy a consent scope.
 *
 * Coverage used to be answered from the connector catalogue: a scope counted as
 * covered when any connected provider *could* supply it, credited to whichever
 * provider came first. That is wrong in both directions. It ticked "sleep,
 * covered by Oura" for a member with no sleep signal at all, and told a member
 * whose movement was arriving every few minutes that movement was uncovered and
 * they should connect a second tracker for it.
 *
 * So coverage is answered from signals instead, and this is the map that lets
 * the server do it. It sits beside the scope enum because both the API and the
 * connectors page need the same answer, and `signalActivityCategory` cannot
 * give it: that groups sleep and heart into one timeline bucket, while consent
 * treats them as separate scopes a member grants independently.
 */
export const SIGNAL_KINDS_BY_SCOPE = {
    "read:signals:sleep": ["wearable.sleep", "wearable.nap"],
    "read:signals:movement": ["wearable.activity", "wearable.workout"],
    "read:signals:heart": ["wearable.hrv", "wearable.rhr"],
    "read:signals:bp": ["wearable.bp.systolic", "wearable.bp.diastolic"],
    "read:signals:glucose": ["wearable.glucose", "lab.hba1c"],
    "read:signals:weight": ["wearable.weight", "self_report.weight"],
    "read:signals:stress": ["wearable.stress"],
    "read:signals:mood": ["survey.pulse"],
    "read:signals:nutrition": ["nutrition.meal", "nutrition.sodium_mg", "hydration.ml"],
    "read:signals:calendar": ["calendar.event"],
    "read:signals:medication": ["medication.dose", "self_report.glp1_dose"],
};
const SCOPE_BY_SIGNAL_KIND = new Map(Object.entries(SIGNAL_KINDS_BY_SCOPE).flatMap(([scope, kinds]) => (kinds ?? []).map((kind) => [kind, scope])));
/** The scope a signal kind satisfies, or null when it feeds no consent scope. */
export function scopeForSignalKind(kind) {
    return SCOPE_BY_SIGNAL_KIND.get(kind) ?? null;
}
//# sourceMappingURL=signal-scopes.js.map